import { useCurrentUserId } from "utils/currentUserHooks";
import Base from "./Modal";

export default function NoAccountModal() {
  const currentUserId = useCurrentUserId();
  return <Base key={String(currentUserId)} />;
}
